(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4000],{

/***/ 18510:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/club",
      function () {
        return __webpack_require__(88096);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 97373:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Hp": function() { return /* binding */ membershipClubFAQs; },
/* harmony export */   "IE": function() { return /* binding */ howClubWorksDeals; },
/* harmony export */   "Kn": function() { return /* binding */ dealsItems; },
/* harmony export */   "Xq": function() { return /* binding */ howClubWorksNoDeals; }
/* harmony export */ });
/* unused harmony export dealsCarouselItems */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_icons_material_Diversity1Outlined__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72349);
/* harmony import */ var _mui_icons_material_MarkEmailReadOutlined__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45419);
/* harmony import */ var _mui_icons_material_CreditCardOffOutlined__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10619);




var dealsItems = [
    {
        title: "Join the Club",
        description: "Be first in line for premium deals before they’re gone.",
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_Diversity1Outlined__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            className: "w-16 h-16 mb-4"
        })
    },
    {
        title: "Get Deal Alerts",
        description: "Receive alerts straight to your inbox — no searching required.",
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_MarkEmailReadOutlined__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            className: "w-16 h-16 mb-4"
        })
    },
    {
        title: "Sign Up for Free",
        description: "We’ll handle the hunt so you can focus on travel plans and never miss an offer.",
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_CreditCardOffOutlined__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            className: "w-16 h-16 mb-4"
        })
    }, 
];
var membershipClubFAQs = [
    {
        heading: "How much can I save with membership in The Club? ",
        content: "First-Class.com searches hundreds of flights to your destination. FlightDeals or First-Class.com exclusive member-only fares ensure that you will receive the best fares around!"
    },
    {
        heading: "Do I need a credit card to sign up? ",
        content: "No, membership is completely free & easy to join"
    },
    {
        heading: "How long does my membership last? ",
        content: "Indefinitely"
    },
    {
        heading: "Do I need to be a member to book? ",
        content: "Yes – you must be a member!"
    },
    {
        heading: "Do I need to login?",
        content: "Yes – to book for You, Friends & Family, just login with your email and password "
    },
    {
        heading: "What are FlightDeals?",
        content: "Thousands of searches are made daily on First-Class.com and we look at the results carefully. We then offer you the best fares in your country - from First-Class.com and selected partners. FlightDeals can be sorted by destination, departure month, cabin class, airlines and alliance – based on YOUR preferences! The more flexible you are, the better the chance you will find an amazing deal to your dream destination!",
        isDealsMarket: true
    },
    {
        heading: "How often will I receive FlightDeal Alerts?",
        content: "Twice a week",
        isDealsMarket: true
    },
    {
        heading: "Can I book hotels?",
        content: "Absolutely! We can book you nearly every hotel in the world! Just use the search engine!"
    },
    {
        heading: "Booking with First-Class.com",
        content: "We offer fabulous member-only fares. If you see a flight you like, just click the link and your easy booking journey begins!"
    },
    {
        heading: "Booking with our partners",
        content: "If you find a cheaper flight with one of our partners, no problem! Just click the link and you are nearly there!"
    },
    {
        heading: "Can I book for my Family & Friends?",
        content: "Yes! The member (you) must make the booking but you can book for all your travel companions!"
    },
    {
        heading: "What is MapMyTravel?",
        content: "Think of MapMyTravel as your personal digital map playpen! It’s a fun & easy to use tool that counts the number of countries that you’ve visited and can create a bucket list of destinations! "
    }, 
];
var howClubWorksDeals = [
    {
        heading: "Start with Your Travel Preferences",
        content: "Log in to add destinations you`ve travelled to or plan to visit."
    },
    {
        heading: "Find the Best Flights & Hotels",
        content: "Search and compare hundreds of premium flight & hotel options worldwide and compare prices in seconds."
    },
    {
        heading: "Receive Instant Deal Alerts",
        content: "Get personalised alerts on member only fares & exclusive discounts sent directly to your inbox"
    },
    {
        heading: "Book with Confidence",
        content: "Book directly with First-Class.com or trusted partners to secure your exclusive fare."
    }, 
];
var howClubWorksNoDeals = [
    {
        heading: "Start with Your Travel Preferences",
        content: "Log in to add destinations you`ve travelled to or plan to visit."
    },
    {
        heading: "Find the Best Flights ",
        content: "Search and compare hundreds of premium flight options worldwide and compare prices in seconds."
    },
    {
        heading: "Look out for member-only fares",
        content: ""
    },
    {
        heading: "Book with Confidence",
        content: "Book directly with First-Class.com or trusted partners to secure your exclusive fare."
    }, 
];
var dealsCarouselItems = [
    {
        image: "/2023/05/1683541291194-La-sagrada-church-closeup.jpg",
        price: 1200,
        currency: "USD",
        destination: "Barcelona",
        origin: "Sydney"
    },
    {
        image: "/2023/06/1686674550987-bejing-skyline-sunset.jpg",
        price: 2200,
        currency: "USD",
        destination: "Beijing",
        origin: "Oslo"
    },
    {
        image: "/2023/06/1686674821190-Doha-skyline-day.jpg",
        price: 1800,
        currency: "USD",
        destination: "Doha",
        origin: "Stockholm"
    },
    {
        image: "/2023/06/1686675794704-Skyline-day.jpg",
        price: 1500,
        currency: "USD",
        destination: "Mumbai",
        origin: "London"
    },
    {
        image: "/2023/06/1686675020483-junkboat-closeup.jpg",
        price: 1200,
        currency: "USD",
        destination: "Hong Kong",
        origin: "New York"
    },
    {
        image: "/2023/06/1686675093264-iolani-place.jpg",
        price: 1500,
        currency: "USD",
        destination: "Honolulu",
        origin: "Los Angeles"
    },
    {
        image: "/2023/06/1686675155346-Hagia-sophia-museum.jpg",
        price: 1800,
        currency: "USD",
        destination: "Istanbul",
        origin: "Paris"
    },
    {
        image: "/2023/06/1686215025026-liberty-statue-.jpg",
        price: 1200,
        currency: "USD",
        destination: "New York",
        origin: "London"
    },
    {
        image: "/2023/06/1686215109178-sydney-opera-close-up.jpg",
        price: 1500,
        currency: "USD",
        destination: "Sydney",
        origin: "Los Angeles"
    }
];


/***/ }),

/***/ 88096:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "MembershipClubHOC": function() { return /* binding */ MembershipClubHOC; },
  "default": function() { return /* binding */ club; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./Layout/Layout.jsx + 7 modules
var Layout = __webpack_require__(24987);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/createTheme.js + 13 modules
var createTheme = __webpack_require__(68239);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 3 modules
var Button = __webpack_require__(69417);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/ThemeProvider.js + 5 modules
var ThemeProvider = __webpack_require__(22430);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./components/MembershipClub/MemebrshipClub.module.scss
var MemebrshipClub_module = __webpack_require__(61731);
var MemebrshipClub_module_default = /*#__PURE__*/__webpack_require__.n(MemebrshipClub_module);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(14416);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/react-intersection-observer/react-intersection-observer.m.js
var react_intersection_observer_m = __webpack_require__(70131);
// EXTERNAL MODULE: ./node_modules/@mui/material/List/List.js + 1 modules
var List = __webpack_require__(78462);
// EXTERNAL MODULE: ./node_modules/@mui/material/ListItem/ListItem.js + 4 modules
var ListItem = __webpack_require__(70891);
// EXTERNAL MODULE: ./node_modules/@mui/material/Divider/Divider.js
var Divider = __webpack_require__(67720);
// EXTERNAL MODULE: ./node_modules/@mui/material/ListItemText/ListItemText.js
var ListItemText = __webpack_require__(59334);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/TaskAlt.js
var TaskAlt = __webpack_require__(27971);
// EXTERNAL MODULE: ./components/MembershipClub/text-configs.js
var text_configs = __webpack_require__(97373);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/CheckCircleOutline.js
var CheckCircleOutline = __webpack_require__(18037);
// EXTERNAL MODULE: ./utils/checkUserCountry.js
var checkUserCountry = __webpack_require__(65024);
;// CONCATENATED MODULE: ./components/MembershipClub/MembershipClub.jsx





// import { useRouter } from 'next/router';
// import { BCBreadcrumbs } from '../index';

// import ScrollableContent from '../ScrollableContent/ScrollableContent';


// import { httpGet } from '../../utils/httpClient';
// import { useWindowWidth } from '@react-hook/window-size';
// import Logo from '../../public/logo.svg';
// import CurrencyFormat from 'react-currency-format';
// import getSymbolFromCurrency from 'currency-symbol-map';




// import ListItemAvatar from '@mui/material/ListItemAvatar';
// import Avatar from '@mui/material/Avatar';
// import Typography from '@mui/material/Typography';
// import CheckIcon from '@mui/icons-material/Check';

// import Image from 'next/image';
// import { DealsCarousel } from '../DealsPage/DealsCarousel/DealsCarousel';



var CallToSignUp = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(8307), __webpack_require__.e(8746)]).then(__webpack_require__.bind(__webpack_require__, 68307));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(68307)
            ];
        }
    }
});
var ScrollableContent = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 55542));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(55542)
            ];
        }
    }
});
var theme = (0,createTheme/* default */.Z)({
    palette: {
        primary: {
            main: "#ffffff"
        },
        secondary: {
            main: "#0a0a0a"
        }
    },
    typography: {
        fontFamily: '"Libre Franklin", sans-serif'
    }
});
// const getRegionOffers = async (filterObj) => {
//   let filterUrl = '';
//   Object.keys(filterObj).forEach((key) => {
//     if (filterObj[key]) {
//       filterUrl += `&${key}=${filterObj[key]}`;
//     }
//   });
//   if (filterUrl.charAt(0) === '&') {
//     filterUrl = filterUrl.slice(1);
//   }
//   const regionOffersRes = await httpGet(
//     `/api/flight/region/offers?${filterUrl}&size=100`
//   );
//   return await regionOffersRes.json();
// };
// const getFeaturedOrigins = async (country) => {
//   const featuredFlightsDealsRes = await httpGet(
//     `/api/flight/popular/origin?country=${country}&cabinClass=BIZ`
//   );
//   return await featuredFlightsDealsRes.json();
// };
function MembershipClub(param) {
    var authCompleted = param.authCompleted, setLoginDialogState = param.setLoginDialogState;
    // const router = useRouter();
    var ref = (0,react.useState)(text_configs/* membershipClubFAQs */.Hp), FAQList = ref[0], setFAQList = ref[1];
    var ref1 = (0,react.useState)(text_configs/* howClubWorksDeals */.IE), howClubWorksList = ref1[0], setHowClubWorksList = ref1[1];
    // const width = useWindowWidth();
    // const [regionalDeals, setRegionalDeals] = useState(null);
    // const [featuredOrigin, setFeaturedOrigin] = useState(null);
    // const [currentRegionIndex, setCurrentRegionIndex] = useState(0);
    var userStore = (0,es/* useSelector */.v9)(function(state) {
        return state.user.value;
    });
    (0,react.useEffect)(function() {
        if (userStore) {
            // getFeaturedOrigins(userStore.country).then((res) => {
            //   const featuredOrigin = { ...res, selectedOrigin: res.origin?.[0] };
            //   setFeaturedOrigin(featuredOrigin);
            // });
            if (!(0,checkUserCountry/* checkUserCountry */.u)(userStore.country)) {
                var filteredFAQs = text_configs/* membershipClubFAQs.filter */.Hp.filter(function(faq) {
                    return faq.isDealsMarket !== true;
                });
                setFAQList(filteredFAQs);
                setHowClubWorksList(text_configs/* howClubWorksNoDeals */.Xq);
            } else {
                setFAQList(text_configs/* membershipClubFAQs */.Hp);
                setHowClubWorksList(text_configs/* howClubWorksDeals */.IE);
            }
        }
    }, [
        userStore
    ]);
    // useEffect(() => {
    //   if (featuredOrigin?.origin && checkUserCountry(userStore?.country)) {
    //     const filterObj = {
    //       country: userStore.country,
    //       currency: userStore.currency,
    //       origin: featuredOrigin?.selectedOrigin,
    //       cabinClass: 'BIZ',
    //     };
    //     getRegionOffers(filterObj).then((offersRes) => {
    //       if (!offersRes.offers) {
    //         setRegionalDeals({ offersByRegion: null });
    //         return;
    //       }
    //       const offersByRegion = offersRes.offers?.reduce((acc, offer) => {
    //         if (!acc[offer.region]) {
    //           acc[offer.region] = [];
    //         }
    //         acc[offer.region].push(offer);
    //         return acc;
    //       }, {});
    //       for (const region in offersByRegion) {
    //         offersByRegion[region].sort((a, b) => {
    //           return a.price - b.price;
    //         });
    //       }
    //       const sortedRegions = Object.keys(offersByRegion).sort((a, b) => {
    //         return offersByRegion[b].length - offersByRegion[a].length;
    //       });
    //       const sortedRegionOffers = {};
    //       sortedRegions.forEach((region) => {
    //         sortedRegionOffers[region] = offersByRegion[region];
    //       });
    //       const regionOffers = {
    //         ...offersRes,
    //         offersByRegion: sortedRegionOffers,
    //       };
    //       console.log(regionOffers);
    //       setRegionalDeals({ ...regionOffers });
    //     });
    //   }
    // }, [featuredOrigin]);
    // useEffect(() => {
    //   if (!regionalDeals?.offersByRegion) return;
    //   const interval = setInterval(() => {
    //     setCurrentRegionIndex(
    //       (prevIndex) =>
    //         (prevIndex + 1) % Object.keys(regionalDeals?.offersByRegion).length
    //     );
    //   }, 5000);
    //   return () => clearInterval(interval);
    // }, [regionalDeals]);
    var CTAButton = function(isLightMode) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                userStore && !userStore.userid && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    className: classnames_default()((MemebrshipClub_module_default()).ctaButton),
                    sx: {
                        fontSize: "1rem",
                        textTransform: "unset",
                        backgroundColor: "#d4a976",
                        width: "225px",
                        borderRadius: "10px",
                        textAlign: "center",
                        textOrientation: "none"
                    },
                    onClick: function() {
                        return setLoginDialogState({
                            opened: true,
                            state: "signUp",
                            sourcePage: "Membership Club Top"
                        });
                    },
                    children: "Sign up for free"
                }),
                userStore && userStore.userid && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    className: "text-white text-lg",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckCircleOutline/* default */.Z, {
                            sx: {
                                color: "#4db060",
                                fontSize: "30px"
                            }
                        }),
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: isLightMode ? "text-black" : "text-white",
                            children: "Congrats! You are already a club member"
                        })
                    ]
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ThemeProvider/* default */.Z, {
        theme: theme,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()((MemebrshipClub_module_default()).topSection),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: classnames_default()((MemebrshipClub_module_default()).topSectionContainer, "px-4 lg:px-6 py-2"),
                    children: [
                        !(0,checkUserCountry/* checkUserCountry */.u)(userStore === null || userStore === void 0 ? void 0 : userStore.country) && (userStore === null || userStore === void 0 ? void 0 : userStore.userid) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "my-10",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                                className: classnames_default()((MemebrshipClub_module_default()).topSectionText, "font-libre"),
                                children: [
                                    "Welcome to ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: "The Club"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                                    className: classnames_default()((MemebrshipClub_module_default()).topSectionText, "font-libre"),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: (MemebrshipClub_module_default()).highlighted,
                                            children: "Save Big"
                                        }),
                                        " on Premium Flights and Hotels"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: classnames_default()((MemebrshipClub_module_default()).subheader, "mb-10"),
                                    children: "Join for free to get exclusive member-only rates and instant travel savings."
                                }),
                                CTAButton()
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()((MemebrshipClub_module_default()).whyJoinContainer),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "container",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "w-full font-fragment text-center",
                            children: "The Secret to the Best Premium Deals?"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mx-auto",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "grid grid-cols-3 sm:grid-cols-1 gap-6 text-center",
                                children: text_configs/* dealsItems.map */.Kn.map(function(column, index) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-col items-center",
                                        children: [
                                            column.icon,
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: classnames_default()((MemebrshipClub_module_default()).highlightWord, "text-xl font-bold"),
                                                children: column.title
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: column.description
                                            })
                                        ]
                                    }, index);
                                })
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (MemebrshipClub_module_default()).content,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "section",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "font-fragment w-full",
                            children: "How The Club works"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* default */.Z, {
                            sx: {
                                width: "100%",
                                bgcolor: "transparent",
                                marginLeft: "0"
                            },
                            className: classnames_default()((MemebrshipClub_module_default()).list, "grid lg:grid-cols-2 gap-4"),
                            children: howClubWorksList.map(function(item, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem/* default */.ZP, {
                                            alignItems: "flex-start",
                                            sx: {
                                                backgroundColor: "#FAF8F4",
                                                minHeight: "100px"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText/* default */.Z, {
                                                primary: /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                    children: item.heading
                                                }),
                                                secondary: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: item.content
                                                })
                                            })
                                        }),
                                        index !== howClubWorksList.length - 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                                            variant: "inset",
                                            component: "li",
                                            className: "list-none"
                                        })
                                    ]
                                }, index);
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "my-3 text-center",
                            children: CTAButton()
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "grid grid-cols-1",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: classnames_default()((MemebrshipClub_module_default()).benefits, "py-12"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "font-fragment w-full text-white",
                            children: "Member benefits"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                            className: "grid lg:grid-cols-2 gap-x-5 gap-y-2",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TaskAlt/* default */.Z, {}),
                                        " Book member-only fares"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TaskAlt/* default */.Z, {}),
                                        " Great savings on flights & hotels"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TaskAlt/* default */.Z, {}),
                                        " Receive deal alerts"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TaskAlt/* default */.Z, {}),
                                        " Add destinations in MapMyTravel"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TaskAlt/* default */.Z, {}),
                                        " Exclusive Offers & Events"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TaskAlt/* default */.Z, {}),
                                        " Premium member-only travel content"
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "container flex flex-col justify-center items-center sm:w-full mb-8 sm:px-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: classnames_default()((MemebrshipClub_module_default()).listTitle, "text-3xl font-fragment my-6"),
                        children: "FAQs"
                    }),
                    FAQList.map(function(faq, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollableContent, {
                            heading: faq.heading,
                            content: faq.content,
                            style: (MemebrshipClub_module_default()).scrollableContent
                        }, index);
                    })
                ]
            }),
            userStore && !userStore.userid && /*#__PURE__*/ (0,jsx_runtime.jsx)(react_intersection_observer_m/* default */.ZP, {
                triggerOnce: true,
                children: function(param) {
                    var inView = param.inView, ref = param.ref;
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                        ref: ref,
                        className: "w-full mx-auto",
                        children: inView && /*#__PURE__*/ (0,jsx_runtime.jsx)(CallToSignUp, {
                            customHeading: "Join First-Class.com The Club",
                            country: userStore === null || userStore === void 0 ? void 0 : userStore.country,
                            authCompleted: authCompleted,
                            sourcePage: "Membership Club bottom"
                        })
                    });
                }
            })
        ]
    });
}

;// CONCATENATED MODULE: ./pages/club.jsx





var MembershipClubHOC = function(param) {
    var authCompleted = param.authCompleted, setLoginDialogState = param.setLoginDialogState;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "canonical",
                        href: "".concat("https://www.first-class.com", "/club")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: "First-Class.com - The Club makes travel planning easy by combining the best deal search and booking in one place. We conduct extensive searches across thousands of airlines and online travel agents, allowing you to compare prices transparently on our website."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "The Club | Best Travel Membership Club | Exclusive Luxury Travel"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MembershipClub, {
                authCompleted: authCompleted,
                setLoginDialogState: setLoginDialogState
            })
        ]
    });
};
/* harmony default export */ var club = ((0,Layout/* withLayout */.X)(MembershipClubHOC, true));


/***/ }),

/***/ 65024:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ checkUserCountry; }
/* harmony export */ });
/* unused harmony export checkUserCountryForBCOnly */
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74907);


var checkUserCountry = function(userCountry, userRegion) {
    if (!userCountry) return false;
    if (userRegion && userCountry === "US") {
        return userCountry === "US" && userRegion === "NY";
    }
    return _config__WEBPACK_IMPORTED_MODULE_0__/* .DEALS_COUNTRIES.includes */ .Yc.includes(userCountry);
};
var checkUserCountryForBCOnly = function(userCountry) {
    if (!userCountry) return false;
    return BC_ONLY_DEAL_COUNTRIES.includes(userCountry);
};


/***/ }),

/***/ 61731:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"topSection":"MemebrshipClub_topSection__ST69o","topSectionContainer":"MemebrshipClub_topSectionContainer__hQ1Yk","topBackground":"MemebrshipClub_topBackground__SzKW_","topSectionText":"MemebrshipClub_topSectionText__f9Df6","highlighted":"MemebrshipClub_highlighted__NfIc9","subheader":"MemebrshipClub_subheader__QFful","ctaButton":"MemebrshipClub_ctaButton__NeWwh","callToSignUpContainer":"MemebrshipClub_callToSignUpContainer__WSKTE","regionContentWrapper":"MemebrshipClub_regionContentWrapper__3fuwp","regionContent":"MemebrshipClub_regionContent__xZD9_","regionGlobeImage":"MemebrshipClub_regionGlobeImage__UDfcn","regionTitle":"MemebrshipClub_regionTitle__m_3Nv","regionItem":"MemebrshipClub_regionItem__Itbnq","regionName":"MemebrshipClub_regionName__QljhH","regionImage":"MemebrshipClub_regionImage__FbkMQ","regionPrice":"MemebrshipClub_regionPrice__5z410","heading":"MemebrshipClub_heading__IWlkK","showDealsButton":"MemebrshipClub_showDealsButton__oAVfN","top":"MemebrshipClub_top__09dk3","content":"MemebrshipClub_content__hMb5H","card":"MemebrshipClub_card__aJtdt","cardImage":"MemebrshipClub_cardImage__lOF5Z","benefitsImage":"MemebrshipClub_benefitsImage__1QqGz","benefits":"MemebrshipClub_benefits___UluH","whyJoinContainer":"MemebrshipClub_whyJoinContainer__dGkEu","highlightWord":"MemebrshipClub_highlightWord__OlFt1","scrollableContent":"MemebrshipClub_scrollableContent__Kdk27","dealsAlerts":"MemebrshipClub_dealsAlerts__OmlzE","dealsCarousel":"MemebrshipClub_dealsCarousel__pqSUY","dealsCarouselItem":"MemebrshipClub_dealsCarouselItem__xSZ0Q","dealImage":"MemebrshipClub_dealImage__QhmNu","dealData":"MemebrshipClub_dealData__1hMHK"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4885,4231,129,1979,7601,9125,5533,6700,632,9780,6420,4987,9774,2888,179], function() { return __webpack_exec__(18510); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);